import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, doc, getDoc, updateDoc } from '@angular/fire/firestore';
import { addDoc } from 'firebase/firestore';
import { SharedService } from 'src/app/shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class HelpSupportModalService {
	supportCategoriesCollection = collection(this.firestore, "supportCategories");
	supportRequestsCollection = collection(this.firestore, "supportRequests");

	constructor(
		private firestore: Firestore,
		private sharedService: SharedService
	) {}

	async getSupportCategoriesData() {
		try {
			const supportCatObs = collectionData(this.supportCategoriesCollection);
			return await this.sharedService.getObservableRes(supportCatObs);
		} catch (err) {
			console.log('Unable to get support categories', err);
		}
	}

	async createSupportRequest(requestData: any) {
		requestData.createdAt = new Date();
		const imageFilesCopy = [...requestData.imageFiles];
		delete requestData.imageFiles;

		try {
			const newDocRef = await addDoc(this.supportRequestsCollection, requestData);

			if (imageFilesCopy && imageFilesCopy.length >= 1) {
				let files: any = [];
				for (let [idx, imageFile] of imageFilesCopy.entries()) {
					const uploadedFileUrl = await this.sharedService.getUrlForUploadedFile(imageFile, `supportRequests/${newDocRef.id}/Screenshot_${idx}.png`);
					files.push(uploadedFileUrl);
				}

				await updateDoc(newDocRef, {
					files
				});
			}
		} catch (err) {
			console.log('Unable to create support request', err);
		}
	}

	async getContactUsEmails() {
		try {
			const docSnap = await getDoc(doc(this.firestore, 'settings/contactUsEmails'));
			return docSnap.data();
		} catch (err) {
			console.log('Unable to get contact emails');
			return {};
		}
	}
}
